// extracted by mini-css-extract-plugin
export default {"sizeGuideLink":"_5066cdf6"};